import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import PendingApproval from "@/pages/PendingApproval";

interface ApprovalRouteProps {
  children: React.ReactNode;
}

const ApprovalRoute = ({ children }: ApprovalRouteProps) => {
  const { user, userRole, isApproved, loading } = useAuth()

  if (loading) {
    return <></>;
  }

  // Se l'utente non è autenticato, reindirizza al login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isApproved) {
    // Il traveler è pending perché non ha ancora impostato la password
    if (userRole === 'traveler') {
      return <Navigate to="/set-password" replace />;
    }
    // Il travel_designer è in attesa di approvazione da parte dell'admin
    return <PendingApproval />;
  }

  // Se l'utente è autenticato e approvato, mostra il contenuto protetto
  return <>{children}</>;
};

export default ApprovalRoute; 